import { ID } from 'shared/types/id';

import { getErrorReporter } from './error-reporter';

export enum FirestoreWriteOp {
  CreatePushToken = 'create-push-token',
  DeletePushToken = 'delete-push-token',
}

type LogFirestoreWriteErrorArguments = {
  op: FirestoreWriteOp;
  error: unknown;
  docPath?: string;
  uid?: ID;
  extra?: Record<string, unknown>;
};

export const logFirestoreWriteError = ({
  op,
  error,
  docPath,
  uid,
  extra,
}: LogFirestoreWriteErrorArguments) => {
  getErrorReporter().captureException(error, {
    tags: { op, docPath, uid },
    contexts: {
      firestoreWrite: {
        op,
        docPath,
        uid,
      },
    },
    extra,
  });
};
